import { render, staticRenderFns } from "./BandejaSeguimientoAnfitrion.vue?vue&type=template&id=6435aff4&scoped=true"
import script from "./BandejaSeguimientoAnfitrion.vue?vue&type=script&lang=js"
export * from "./BandejaSeguimientoAnfitrion.vue?vue&type=script&lang=js"
import style0 from "./BandejaSeguimientoAnfitrion.vue?vue&type=style&index=0&id=6435aff4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6435aff4",
  null
  
)

export default component.exports